function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "7r6ryos8ia"
}, /*#__PURE__*/React.createElement("path", {
  transform: "translate(1.329)",
  d: "M0 0h24v24H0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.768 13.959 11.817 20a2.181 2.181 0 0 0 3.473.015l6.072-6.072a2.188 2.188 0 0 0-.015-3.481l-6.042-6.04a2.188 2.188 0 0 0-3.481-.015l-6.071 6.071a2.193 2.193 0 0 0 .015 3.481zm6.953 1.974a.882.882 0 0 1-.731-.4l-1.846-2.245a.834.834 0 0 1-.2-.535.691.691 0 0 1 .686-.7.729.729 0 0 1 .61.331l1.454 1.846 3.116-4.987a.7.7 0 0 1 .61-.392.684.684 0 0 1 .716.655 1.057 1.057 0 0 1-.2.527l-3.526 5.5a.827.827 0 0 1-.689.4z",
  transform: "translate(-.557 -.507)"
});

function SvgCheckedRombFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.329)",
    style: {
      clipPath: "url(#7r6ryos8ia)"
    }
  }, _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedRombFilled);
export default __webpack_public_path__ + "static/media/checked_romb_filled.5d29cc24.svg";
export { ForwardRef as ReactComponent };